module.exports = __webpack_public_path__ + "img/agentOperation_basic.59760285.png";